import { FiltroComunicadoDTO } from '../shared/dto/filtroComunicadoDTO';
import createAxiosInstance from './axiosConfig';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/comunicadoConfirmacaoController');

export default class ComunicadoConfirmacaoService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }

  async listarTodosComunicadosConfirmacao(page = 0, size = 10, filtros?: any) {
    const requestData = {
      page,
      size,
      filtros: filtros || undefined
    };
    
    return await this.axios.post('/listarTodosComunicadosConfirmacao', requestData);
  }

  async listarTodosComunicadosConfirmacaoUuid(uuid: string, page = 0, size = 5) {
    return await this.axios.post('/listarTodosComunicadosConfirmacaoUuid', { uuid, page, size });
  }


}